// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.governors-filter {
  grid-template-columns: minmax(210px, 1fr) minmax(180px, 0.8fr) auto;
  align-items: end;
  column-gap: 16px;
  padding: 16px;
  border-color: var(--border-subtle, #dbe3ec);
  background: var(--surface-subtle, #f8fafc);
  box-shadow: none;
}

.governors-filter .people-filter__field {
  gap: 7px;
}

.governors-filter .people-filter__field > span {
  color: var(--text-body, #334155);
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.governors-filter .governors-filter__control {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background-color: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  line-height: 1;
  font-weight: 650;
  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
}

.governors-filter .governors-filter__control::placeholder,
.governors-filter .governors-filter__control--placeholder {
  color: var(--text-muted, #64748b);
  font-weight: 550;
}

.governors-filter .governors-filter__select {
  padding-right: 36px;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 11px center;
  cursor: pointer;
}

.governors-filter .governors-filter__control:hover {
  border-color: var(--border-strong, #94a3b8);
}

.governors-filter .governors-filter__control:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));
}

.governors-filter .people-filter__actions {
  align-self: end;
  min-height: 38px;
  transform: translateY(-9px);
}

.governors-filter .people-filter__actions .people-btn {
  height: 38px;
  min-height: 38px;
}

@media (max-width: 720px) {
  .governors-filter {
    grid-template-columns: 1fr;
  }

  .governors-filter .people-filter__actions {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Users/Governors/Governors.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,2CAA2C;EAC3C,kCAAkC;EAClC,mEAAmE;EACnE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uFAAuF;AACzF;;AAEA;;EAEE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wQAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".governors-filter {\n  grid-template-columns: minmax(210px, 1fr) minmax(180px, 0.8fr) auto;\n  align-items: end;\n  column-gap: 16px;\n  padding: 16px;\n  border-color: var(--border-subtle, #dbe3ec);\n  background: var(--surface-subtle, #f8fafc);\n  box-shadow: none;\n}\n\n.governors-filter .people-filter__field {\n  gap: 7px;\n}\n\n.governors-filter .people-filter__field > span {\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.governors-filter .governors-filter__control {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background-color: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  line-height: 1;\n  font-weight: 650;\n  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;\n}\n\n.governors-filter .governors-filter__control::placeholder,\n.governors-filter .governors-filter__control--placeholder {\n  color: var(--text-muted, #64748b);\n  font-weight: 550;\n}\n\n.governors-filter .governors-filter__select {\n  padding-right: 36px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 11px center;\n  cursor: pointer;\n}\n\n.governors-filter .governors-filter__control:hover {\n  border-color: var(--border-strong, #94a3b8);\n}\n\n.governors-filter .governors-filter__control:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));\n}\n\n.governors-filter .people-filter__actions {\n  align-self: end;\n  min-height: 38px;\n  transform: translateY(-9px);\n}\n\n.governors-filter .people-filter__actions .people-btn {\n  height: 38px;\n  min-height: 38px;\n}\n\n@media (max-width: 720px) {\n  .governors-filter {\n    grid-template-columns: 1fr;\n  }\n\n  .governors-filter .people-filter__actions {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
